export enum PageId {
    /** @deprecated DO NOT USE! This page has own entry point */
    MAIN = 'main',
    /** @deprecated DO NOT USE! This page has own entry point */
    HISTORY = 'history',
    /** @deprecated DO NOT USE! This page has own entry point */
    SELECTION = 'selection',
    /** @deprecated DO NOT USE! This page has own entry point */
    FILM = 'film',
    /** @deprecated DO NOT USE! This page has own entry point */
    PROFILES = 'profiles',
    /** @deprecated DO NOT USE! This page has own entry point */
    PROFILE_SETTINGS = 'profileSettings',
    /** @deprecated DO NOT USE! This page has own entry point */
    AGE_RESTRICTION = 'age-restriction',
    /** @deprecated DO NOT USE! This page has own entry point */
    CHANNELS = 'channels',
    /** @deprecated DO NOT USE! This page has own entry point */
    PERSONAL = 'personal',
    LOGIN = 'login',
    /** @deprecated DO NOT USE! This page has own entry point */
    ADMIN_FAMILY_ADD = 'admin-family-add',
    /** @deprecated DO NOT USE! This page has own entry point */
    SETTINGS = 'settings',
    /** @deprecated DO NOT USE! This page has own entry point */
    PERSON = 'person',
    /** @deprecated DO NOT USE! This page has own entry point */
    MUSIC = 'music',
    /** @deprecated DO NOT USE! This page has own entry point */
    YASMINA = 'yasmina',
    /** @deprecated DO NOT USE! This page has own entry point */
    CRUNCHYROLL = 'crunchyroll',
    /** @deprecated DO NOT USE! This page has own entry point */
    SHOWCASE = 'showcase',
}
